import notificationError from '@/utils/functions/notificationError';
import { notification } from 'antd';
import { useMutation } from 'react-query';
import { getReportGenerateCrmNextRevision } from './reports-generate.services';

export function useReportsGenerateCrmNextRevision() {
  return useMutation({
    mutationFn: getReportGenerateCrmNextRevision,
    onSuccess() {
      notification.success({ message: 'Relatório gerado com sucesso!' });
    },
    onError(error) {
      notificationError(error);
    },
  });
}
